export default __webpack_public_path__ + "static/media/accordian-arrow-down.93e4e5a3.svg";